export const LandingPageVideoContentENUSTranslations = {
  landingPageVideoSubtitle: 'COLLABORATIVE DECISION-MAKING PLATFORM',
  landingPageVideoTitle:
    'We make it easy for everyone - from business executives to specialists - to work together with data and AI-driven forecasts that generate ROI',
  landingPageStartVideoTitle: 'Vídeo sobre nossa empresa',
};
